import React from 'react'
import {useRouteManagement} from '../RouteManagementProvider'
import {KTIcon} from '../../../../_metronic/helpers'
import {useMutation, useQueryClient} from 'react-query'
import axios, {AxiosResponse} from 'axios'
import {BASE_URL} from '../../config'
import toast from 'react-hot-toast'

const DELETE_SENDER_ROLE_URL = `${BASE_URL}/api/protect/deleteRouteSenderRoles`

const DeleteSenderRouteRole = () => {
  const queryClient = useQueryClient()

  const {selectRouteSenderRole, setSelectRouteSenderRole} = useRouteManagement()

  const {mutateAsync: deleteSenderRouteRole} = useMutation<AxiosResponse>({
    mutationFn: async () => {
      const response = await axios.delete(`${DELETE_SENDER_ROLE_URL}/${selectRouteSenderRole?.id}`)

      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['createRouteSenderRoles'])
    },
  })

  const onClose = () => {
    setSelectRouteSenderRole(null)
  }

  const onDelete = async () => {
    toast.loading('Deleteing..')
    const response = await deleteSenderRouteRole()
    const result = await response.data

    if (response.status === 200) {
      toast.dismiss()
      toast.success(result.message)
    } else {
      toast.dismiss()
      toast.error(result.message)
    }
  }

  return (
    <div className='modal fade' tabIndex={-3} id='kt_modal_3'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-md p-12'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Delete Route</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onClose}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            {selectRouteSenderRole ? (
              <>
                <p className='fs-4 fw-semibold text-danger text-center m-0'>
                  Are you sure? <br />
                </p>
                <p className='fs-4 fw-semibold text-danger text-center'>
                  You want to delete {selectRouteSenderRole.name}? <br />
                </p>

                <div className='text-center pt-15'>
                  <button
                    type='reset'
                    className='btn btn-light me-3'
                    data-kt-users-modal-action='cancel'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={onClose}
                  >
                    Discard
                  </button>

                  <button
                    type='submit'
                    className='btn btn-danger'
                    data-kt-users-modal-action='submit'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={onDelete}
                  >
                    <span className='indicator-label'>Delete</span>
                  </button>
                </div>
              </>
            ) : (
              <p className='fs-4 fw-semibold text-center'>Loading..</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteSenderRouteRole
